export enum InspectorInfoTypes {
    Layer = 'layer',
    Lithology = 'curve',
    Perforation = 'perforation',
    Well = 'well',
    Group = 'group',
}

export interface InspectorInfo {
    type: InspectorInfoTypes;
    data: unknown;
    title: string;
}

export interface InspectorState {
    geoObjects: {
        [key: string]: GeoVersion[];
    };
    inspectorInfo: InspectorInfo;
}

export interface GeoVersion {
    stratumVersionId: number;
    isVisible: boolean;
}
